'use client';

import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { ServiceLayer } from '@packages/modules/src/ServiceLayer/ServiceLayerComponents.client';

export type SizeTableProps = {
  serviceLayerId: string;
};

export const SizeTable = ({ serviceLayerId }: SizeTableProps) => {
  const { formatMessage } = useIntl();

  const [isOpen, setIsOpen] = React.useState(false);

  const handleButtonClick = () => {
    setIsOpen((prev) => !prev);
  };
  const handleDialogClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        variant="textLink"
        onClick={handleButtonClick}
        className="flex flex-nowrap items-center gap-1"
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <span className="icon-emp-size-chart" aria-hidden="true" />
        {formatMessage({
          id: 'sizeTable.button.text',
          defaultMessage: 'Größentabelle öffnen',
        })}
      </Button>
      {isOpen && (
        <Dialog variant="bottomSheet" isOpen onClose={handleDialogClose}>
          <DialogHeader onClose={handleDialogClose}>
            {formatMessage({
              id: 'sizeTable.dialog.header',
              defaultMessage: 'Größentabelle',
            })}
          </DialogHeader>
          <DialogContent>
            <ServiceLayer serviceLayerId={serviceLayerId} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
